import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

const getSchema = (type) =>
  yup.object({
    statementFormat: yup
      .string()
      .label("statementFormat")
      .oneOf(["PDF", "CSV"]),
    startDate: yup.string().required("Start date is required"),
    endDate: yup.string().required("End date is required"),
    walletId:
      type === "debtor" ||
      type === "ledger" ||
      type === "cash" ||
      type === "bank"
        ? yup.string().nullable()
        : yup.string().required("Wallet is required"),
    selectedStore:
      type === "cash"
        ? yup.string().required("Store id is required")
        : yup.string().nullable(),
    selectedBank:
      type === "bank"
        ? yup.string().required("Bank id is required")
        : yup.string().nullable(),
  });

const Validation = (
  statementFormat,
  startDate,
  endDate,
  walletId,
  type,
  selectedStore,
  selectedBank,
) => {
  return useForm({
    resolver: yupResolver(getSchema(type)),
    shouldFocusError: true,
    mode: "onBlur",
    defaultValues: {
      walletId,
      statementFormat,
      startDate,
      endDate,
      selectedStore,
      selectedBank,
    },
  });
};

export default Validation;
